<div class="flex flex-col gap-2">
  @if (label) {
    <span class="text-general text-var(--color-text-primary) font-bold!">{{
      label | translate
    }}</span>
  }

  <mat-radio-group aria-label="Select an option " [formControl]="getInputGeneral()">
    <div class="flex flex-wrap gap-2">
      @for (item of arrayData; track item) {
        <div
          [ngClass]="{
            'cursor-pointer': this.formControlGeneral?.enabled,
          }"
          class="rounded-xl border border-(--comp-input-file-border) shadow-xl inset-shadow-sm flex p-3 gap-2 w-fit flex-col"
          (click)="changeValue(item)"
        >
          <div class="flex gap-2 items-center justify-between">
            <div>
              {{
                InputSelectRadioButton.nameCards
                  ? getNestedProperty(item, InputSelectRadioButton.nameCards)
                  : item
              }}
            </div>

            <mat-radio-button
              [value]="
                InputSelectRadioButton.value === ''
                  ? item
                  : getNestedProperty(item, InputSelectRadioButton.value)
              "
            ></mat-radio-button>
          </div>

          @if (InputSelectRadioButton.description) {
            <div class="text-base">
              {{
                InputSelectRadioButton.description
                  ? getNestedProperty(item, InputSelectRadioButton.description)
                  : ''
              }}
            </div>
          }
        </div>
      }
    </div>
  </mat-radio-group>

  @if (formControlGeneral?.hasError('required')) {
    <div class="mat-error">{{ 'inputs.required' | translate }}</div>
  }
  @if (
    formControlGeneral && formControlGeneral.errors && formControlGeneral.errors['errorGeneral']
  ) {
    <div class="mat-error">
      {{ formControlGeneral.errors['errorGeneral'] }}
    </div>
  }
</div>
